import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPenToSquare, faSearch } from '@fortawesome/free-solid-svg-icons'
import { ClienteService } from "../../services/api/Clientes/ClienteService";
const ClienteList = ({ listCliente, handleDelete, setIsloading, listPermissoes }) => {


    return (
        <>

            {listCliente.map((item, key) => (
                <tr key={key}>
                    <td>{item.id}</td>
                    <td>{item.nome} {(item.sobrenome != null) ? item.sobrenome : ''}</td>
                    <td>

                        {item?.animais?.map((animal, key) => (
                            <>
                              {/*  <a href={'/admin/animais/ficha/' + animal.id}>{animal.nome}</a>*/}
                               {animal.nome}
                                {((key + 1) < item.animais.length) ? ', ' : ''}
                            </>


                        ))}
                    </td>
                    <td className=" ">{item.observacoes}</td>
                      <td className="text-center">
                            <Button size="sm" variant="info" onClick={() => setIsloading(true)} href={'/admin/clientes/' + item.id} title="Ver ficha" className="mr-10"><FontAwesomeIcon icon={faSearch} /></Button>


                    </td>
                    <td className="text-center">
                        {(listPermissoes?.editar) ?
                            <Button size="sm" variant="primary" onClick={() => setIsloading(true)} href={'/admin/clientes/cadEdit/' + item.id} title="Editar" className="mr-10"><FontAwesomeIcon icon={faPenToSquare} /></Button>

                            : ''}

                    </td>
                    <td className="text-center">
                        {(listPermissoes?.excluir) ?
                            <Button size="sm" variant="danger" title="Excluir" onClick={() => handleDelete(item.id)}><FontAwesomeIcon icon={faTrash} /></Button>

                            : ''}
                    </td>



                </tr>


            ))}
        </>
    )

}

export default ClienteList;